var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { FlexAlignItems, Grid } from '../../common/components/Grid';
import { VisualNavigation, } from '../../common/components/VisualNavigation';
import { SliderTitle } from '../../common/components/Text';
var defaultEventData = {
    event: 'visualNavigationTracking',
    eventData: { placement: 'visualNavigationSlide' },
};
var VisualNavigationGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
VisualNavigationGrid.defaultProps = {
    py: 0,
    px: ['sp_16', 'sp_24', '36px', 'sp_64'],
    mb: ['sp_16', 'sp_24', null, 'sp_32'],
    alignItems: FlexAlignItems.CENTER,
};
export var CommonVisualNavigation = function (_a) {
    var __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width, title = _a.title, sliderProps = __rest(_a, ["__legacy_shop_reboot_max_width", "title"]);
    return (React.createElement(VisualNavigationGrid, { "data-testid": "visual-navigation-grid", legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
        React.createElement(SliderTitle, { "data-testid": "visual-navigation-title" }, title),
        React.createElement(VisualNavigation, __assign({}, sliderProps, { trackingData: defaultEventData }))));
};
CommonVisualNavigation.propTypes = __assign(__assign({}, VisualNavigation.propTypes), { 
    /** Title of the section */
    title: PropTypes.string.isRequired, 
    /** Should the max width be capped by current Reboot max width (default: true) */
    __legacy_shop_reboot_max_width: PropTypes.bool });
CommonVisualNavigation.defaultProps = {
    seeAllLink: null,
    __legacy_shop_reboot_max_width: true,
};
export default CommonVisualNavigation;
var templateObject_1;
